import { Controller } from "@hotwired/stimulus";
import { openModal } from "../../utils/misc";
import { flashAlert } from "../../components/flash_alert";

export default class extends Controller {
  static targets = ["invoiceContainer"];

  invoiceContainerTargetConnected() {
    openModal("mobile-purchase-invoice-validation-modal");
  }

  documentValidated(event) {
    flashAlert(event.params.documentValidatedSuccessMessage);
  }
}
